// opervex-frontend/src/services/ReasonPromptService.js

import React, { useState } from "react";
import { createRoot } from "react-dom/client";

const ReasonPromptService = {
  show: (title, message) => {
    return new Promise((resolve) => {
      const container = document.createElement("div");
      document.body.appendChild(container);

      const ReasonModal = () => {
        const [reason, setReason] = useState("");

        const handleClose = () => {
          resolve(null);
          root.unmount();
          container.remove();
        };

        const handleConfirm = () => {
          resolve(reason.trim());
          root.unmount();
          container.remove();
        };

        return (
          <div style={styles.overlay}>
            <div style={styles.modal}>
              <h2>{title}</h2>
              <p>{message}</p>
              <textarea style={styles.textarea} value={reason} onChange={(e) => setReason(e.target.value)} />
              <div style={styles.actions}>
                <button onClick={handleClose}>Cancelar</button>
                <button onClick={handleConfirm} disabled={!reason.trim()}>
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        );
      };

      const root = createRoot(container);
      root.render(<ReasonModal />);
    });
  },
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    background: "#fff",
    padding: "1.5rem",
    borderRadius: "8px",
    width: "400px",
    maxWidth: "90%",
    boxShadow: "0 0 10px rgba(0,0,0,0.25)",
  },
  textarea: {
    width: "100%",
    minHeight: "80px",
    marginTop: "10px",
    marginBottom: "10px",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
};

export default ReasonPromptService;
